import * as Yup from "yup";

export const chargingSchema = Yup.object().shape({
  id: Yup.string().required("ID is required."),
  cardNumber: Yup.string()
    .required("Card number is required.")
    .min(4, "Card number must be at least 4 characters."),
});

